module.exports = __webpack_public_path__ + "img/LBA_logo_big.559beefb.png";